import React,{useState,useEffect} from 'react'
import MaterialTable from 'material-table';
import Axios from 'axios';


import {MDBRow, MDBCol, MDBContainer,MDBIcon,MDBModal,MDBCard,MDBCardBody,
    MDBCardHeader,MDBCardFooter,  } from 'mdbreact';
    import { toast,ToastContainer } from 'react-toastify';



import "../css/scrollbar.css";

import AccessDenied from '../components/AccessDenied';





const InventoryDetails=(props)=>{

  const bearer={
    headers: {
       Authorization: "Bearer " + sessionStorage.getItem("hash")
    }
  }
  const [rows, setRows] = useState([]);
  const [showPreloader,setPreloader]=useState("normal");

  const [selRow,setSelectedRow]=useState("");
   
  const [modalAddEdit,showAddEdit]=useState(false);


  const toggleAddEdit = (transtype) => {

   
    setRows([]);
   
   
        showAddEdit(!modalAddEdit);
   
    loadData();
  
  }
  
 

  const toastId = React.useRef(null);

  const notify = (message) => {
      toastId.current = toast.info(message);
    
    }


  const [bRefresh,setRefresh]=useState(false);

 const refreshGrid =(message)=>{
   
     setRows([]);
      setRefresh(!bRefresh);
   
      loadData();
      notify(message);
      
    
    
  }


  const showResult =(message)=>{
    setRefresh(!bRefresh);
  
    setRows([]);
  
   
    // loadData(); 
  
    loadData();
   
  
    toast.info(message, {
        closeButton: false
        
      });
    
    
  }

  const [isAdmin,checkAdmin]=useState(0);


         
  function checkAdminAccess() {
      
  
    Axios.get(props.apiServer + "/getadminaccess?username=" + sessionStorage.getItem("msal.uc"),bearer)
     .then(res => {
     
        checkAdmin(0);
        checkAdmin(res.data[0].isadmin);
        setPreloader("none");
     })
   
     .catch(error => {
      
      console.log(error);
     });  
    
   
   
   
   }
   
  function loadData() {
    
    Axios.get(props.apiServer + "/getinventorydetailslist?code=" + props.period,bearer)
     .then(res => {
       
       setRows(res.data);
        setPreloader("none");
    
     })
   
     .catch(error => {
      
      console.log(error);
     });  
    
   
   
   
   }


  const useMountEffect = (functionName) => useEffect(functionName, [])


  useMountEffect(checkAdminAccess);
    useMountEffect(loadData);

  

if( isAdmin==0 ) 
{

  return (
    <React.Fragment>

    <AccessDenied />
    </React.Fragment>
   
    
    );
}
  
 

  return (
    <React.Fragment > 

       <MDBRow className="mt-4 pt-4"> 
      
            <MDBCol  md="12">
            { showPreloader==="normal" ? 
              ( 

                <MDBRow>
                <MDBCol md="4">

                </MDBCol>
                <MDBCol  md="4" className="text-center">
                <br/>  
                <img src={props.deployURL + "/loading.gif" } style={{width:"300px",textAlign:"center"}} alt="loading" />
                <br/>
                
                </MDBCol>
                <MDBCol  md="4">
                  
                </MDBCol>


              </MDBRow>
            
              )
              :
              (
                <React.Fragment>
                
                <MDBRow>
                <MDBCol md="12">
                
                <h6  style={{fontFamily:"Montserrat",fontWeight:"400"}} className="display-5 blue-grey-text ml-1 mt-0 pt-0"> Inventory Details ({props.period})</h6>
                   
                 </MDBCol>
              
                  
                </MDBRow>
               
                <MaterialTable

                  title=""


                //   SELECT  [code],[itemcode],[received],[receivingcode],[dispensed],[salesmaincode],
                //[returned],[backordercode],[datefrom],[dateto],[generatedby],[transactiontype],[transactiondatetime],[generateddatetime],[acquisitioncost],[period],[],[barcode],[seniordiscountable],[pwddiscountable],[itemcategory],[supplier] FROM [vwInventoryPosting]
                  columns={[
                   
                    { title: "transactiondatetime", field: 'transactiondatetime'
                      
                    },
                    { title: "Item", field: 'description',
                      
                    },
                    { title: "Barcode", field: 'barcode',defaultGroupOrder: 0 
                      
                    },
                    { title: 'Received', field: 'received'
                    

                    },
                   
                    { title: 'Dispensed', field: 'dispensed'

                    }
                    ,
                    { title: 'Returned', field: 'returned'

                    }
                    ,
                    { title: 'Transaction Type', field: 'transactiontype'

                  }
                  ,
                  { title: "itemcode", field: 'itemcode',
                      
                 },
                  ]}




                  data={rows
                  }



                  options={{
                    search: true,
                   
                    grouping: true
                  }}






                    />  


               
                </React.Fragment>
              )
              
              
            
            }

            </MDBCol>
        </MDBRow>
       



          
            

          <ToastContainer
                hideProgressBar={true}
                newestOnTop={true}
                autoClose={2000}
               
                />
     {/*    <ToastContainer
                        hideProgressBar={true}
                        newestOnTop={true}
                        autoClose={5000}
                    /> */}
                  
    </React.Fragment>
   
  )
}



export default InventoryDetails
